import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";

import "./bryntum-lib/columns/RegisterColumns.jsx";
import "./bryntum-lib/widget/fields/RegisterFields.jsx";
import "./bryntum-lib/plugins/PluginsBryntumClasses.jsx";
import "./bryntum-lib/overrides/OverriddenBryntumClasses.jsx";
import "./bryntum-lib/widget/extendingClasses/RegisterWidgetOverridden.jsx";

import Loader from "./react/components/loader/Loader";
import AdminRoutes from "./react/routes/AdminRoutes.jsx";
import ReactToast from "./react/components/ReactToast.jsx";
import ErrorBoundary from "./react/components/error/ErrorBoundary";
import { AuthContextProvider } from "./react/context/authContext.jsx";

import "./index.css";
import 'intl-tel-input/build/js/utils';
import "react-toastify/dist/ReactToastify.css";
import "intl-tel-input/build/css/intlTelInput.css"
import "./sentryIntegration.jsx";
import "./logRocketIntegration.jsx";
import "./googlePlacesIntegration.jsx"
import { ConfirmDialogProvider } from "@omit/react-confirm-dialog";

ReactDOM.render(
  <ErrorBoundary>
    <Router>
      <AuthContextProvider>
        <div className="min-h-screen AppView">
          <Loader />
          <ConfirmDialogProvider>
            <Switch>
              <Redirect from="/invite" exact to={{ pathname: "/", search: window.location.search }} />
              <AdminRoutes />
            </Switch>
          </ConfirmDialogProvider>
          <ReactToast />
        </div>
      </AuthContextProvider>
    </Router>
  </ErrorBoundary>,
  document.getElementById("root")
);
